const doc = [({"ja":({"pattern1":"検索フォーム, メイン画像", "pattern2":"メイン画像、検索フォーム"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;